interface Camp {
  id: string;
  slug: string;
  title: { HU: string; RS?: string; EN?: string };
  description: { HU: string; RS?: string; EN?: string };
}

export const camps: Camp[] = [
  {
    id: '1',
    slug: 'szinesztabor',
    title: { HU: 'Színésztábor', RS: 'Glumački kamp', EN: 'Acting Camp' },
    description: {
      HU: `
> Vezető: **Mészáros Gábor**, színházigazgató, színész

Idén sem hagyunk benneteket világraszóló deszkák nélkül, perszehogy lesz színész workshopunk!

"A színházban mindig az igazság érdekel. A dolgok igaza, a mondatok igaza, a jelenlét igazsága. A színészet alárendelt művészeti ág, azonban ebben az alárendeltségben nagy szabadsága van az alkotónak, hiszen ebben a szabadságban mely keretek között van ugyan, de fel kell építeni az igazságot. Minden pillanatét. Az akciót végre kell hajtani, ám az akció tartalma, a színész belső tartalma. Itt bontakozik ki a színész világa amely alá van rendelve a pillanat aktusának. Ez az igazság érdekel. A pillanaté, amely a színész által időben és térben értelmetkap s közvetít."

A táborok időtartama augusztus 2-6.

Részvételi díj 8500 dinár, amely tartalmazza a napi 3 étkezést, az oktatók, előadók díját és fedeti a délutáni-esti programok költségeit.

A tábor díjából **5000 dinár előleg a jelentkezéskor fizetendő** - az előleg lemondás esetén **nem visszatérítendő**, de átruházható! A tábor ára nem tartalmazza a Malomfesztivál bérlet árát, ugyanakkor kedvezményes, **2000 dináros fesztiválbérlet megváltására jogosítja fel a résztvevőket.**

Maximális létszám táboronként: 20 fő

Korhatár: minimum 16 év

**Jelentkezési határidő: Július 20.**

Jelentkezzz emailben: onyaolahdora@gmail.com`,
      RS: 'Kamp za koji se interesujete je isključivo na mađarskom jeziku.',
      EN: 'The camp you are interested in is only in Hungarian language.',
    },
  },
  {
    id: '2',
    slug: 'filozz',
    title: { HU: 'Filozófiatábor', RS: 'Filozofski kamp', EN: 'Philosophy Camp' },
    description: {
      HU: `
> A társadalmi és politikai gondolkodás műhelye

**Táborvezető: Sárcsevity Hajdú Bea** szociális munkás, szociálpolitikus, főiskolai és középiskolai tanár, civil aktivista

A demokrácia nemcsak intézményekről szól, hanem arról is, hogyan gondolkodunk, döntünk, és hogyan élünk együtt másokkal. Nem működik automatikusan - a részvételünk teszi élővé.

Ez a program abban segít, hogy jobban rálássunk saját helyzetünkre a társadalomban, megértsük a rendszerszintű egyenlőtlenségeket, az állampolgári jogok működését, és azt, milyen lehetőségeink vannak a cselekvésre.

Témáink többek között:

- hogyan jelennek meg az egyenlőtlenségek a mindennapokban
- mit jelent a jogainkkal élni (vagy nem tudni élni)
- hogyan működik - vagy nem működik - a demokrácia
- mi a felelősségünk egyénként és közösségként

Gyere és beszélgetünk, kérdezünk, vitatkozunk. Itt teret adunk a közös gondolkodásnak, és eszközöket keresünk a részvételhez.

A Filózz! alkotótábor a társadalmi és politikai gondolkodás műhely a Szerbiai Kolping Társaság támogatásával együtt valósul meg.

A táborok időtartama augusztus 2-6.

Részvételi díj 8500 dinár, amely tartalmazza a napi 3 étkezést, az oktatók, előadók díját és fedeti a délutáni-esti programok költségeit.

A tábor díjából **5000 dinár előleg a jelentkezéskor fizetendő** - az előleg lemondás esetén **nem visszatérítendő**, de átruházható! A tábor ára nem tartalmazza a Malomfesztivál bérlet árát, ugyanakkor kedvezményes, **2000 dináros fesztiválbérlet megváltására jogosítja fel a résztvevőket.**

Maximális létszám táboronként: 20 fő

Korhatár: minimum 16 év

**Jelentkezési határidő: Július 20.**

Jelentkezz emailben: onyaolahdora@gmail.com`,
      RS: 'Kamp za koji se interesujete je isključivo na mađarskom jeziku.',
      EN: 'The camp you are interested in is only in Hungarian language.',
    },
  },
  {
    id: '3',
    slug: 'muvesztelep',
    title: {
      HU: 'Művésztelep',
      RS: 'Umetnički kamp',
      EN: 'Art Residency',
    },
    description: {
      HU: `A **Wemsical Serbia Ifjúsági és Kulturális Egyesület** projektpartnereivel együttműködésben művészeti rezidenciaprogramot hirdet a Parks4All projekt keretében. A program célja, hogy körülöttünk lévő parkokat, zöldterületeket egy új módon, a művészeteken keresztül dolgozzuk fel, használjuk, hasznosítsuk és újragondoljuk. A projektet az Interreg VI-A IPA Magyarország–Szerbia Program társfinanszírozza.

A rezidenciaprogram javasolt központi témája a **tiltakozás**. Célunk az erőszaktól és pártpolitikától mentes mozgalmak támogatása, értelmezése és dokumentálása – olyan mozgalmaké, amelyek az alapvető közös emberi értékeket, az egyenlőséget, az emberi jogokat, az erkölcsi és etikai normákat, valamint a közös, átlátható és fenntartható jövőért való együttműködést képviselik.

A projekt lehetőséget kíván biztosítani az olyan kifejezési formák számára, amelyek hangosabbak a szavaknál és látványosabbak az agitprop plakátoknál.

Ez egy felhívás számodra, hogy jelentkezz, és valósítsd meg az ötleteidet Orom hangulatos kis parkjában, összekapcsolódva a Malomfesztivállal.

## Amit kínálunk:
- **500 euró** az alkotói munka alapvető költségeinek fedezésére
- **Napi három étkezés** 2025. július 28. és augusztus 7. között
- **Kiváló előadók és tematikus esti programok**
- **Belépő az idei Malomfesztiválra**

Nincsenek technikai megkötéseink; a létrehozott alkotás lehet vizuális művészeti alkotás, tájépítészeti elem, installáció, performansz, film vagy bármi más, ami a park / nyilvános zöld tér és a Malomfesztivál kontextusában értelmezhető.

## Amit elvárunk:
Az alkotás legyen a témához szabva, vizuálisan magával ragadó, és alkalmas a fesztivál terepéhez és ellenálló az időjárási viszonyokkal szemben.

**Megvalósulás:** 2025. július 28. – augusztus 10. (rövidebb részvétel is lehetséges)

## Pályázati feltételek:
- **Motivációs levél** (legfeljebb 1 A4-es oldal, amely tartalmazza az alkotó(k) nevét, elérhetőségét, születési dátumát és lakóhelyét)
- **Szakmai portfólió**
- **Terv / ötlet** egy helyben elkészítendő vagy ott kiállítandó munkára

**Pályázati határidő:** 2025. június 30., 23:59:59  
**A pályázatok elbírálásának határideje:** 2025. július 5.

**A jelentkezéseket az alábbi e-mail címre kell elküldeni:** onyaolahdora@gmail.com

## Kik pályázhatnak?
A pályázat nyitott minden **36 év alatti** természetes személy vagy alkotócsoport számára, független hivatásos vagy félprofi alkotók számára.

Legfeljebb **3 főből álló alkotócsoportok** pályázatait fogadjuk – az átlagéletkor legfeljebb 36 év. A csoportok tagjai származhatnak Magyarországról és / vagy Szerbiából.

A részvétel egyéni munkán alapul (technikai segítők, mentorok vagy szakmai asszisztencia nem biztosított, de bizonyos esetekben elérhető lehet).

**A műhely munkanyelve az angol.**

A pályázat benyújtásával a pályázók vállalják, hogy terveiket legjobb tudásuk szerint megvalósítják, alkotásaikat legkésőbb **2025. augusztus 6-án 14 óráig** a helyszínen felállítják, azokat a Malomfesztivál ideje alatt bemutatják, és felelősséget vállalnak értük.

Néhány szó a Parks4All projektről [ezen a linken](http://www.hungary-serbia.eu) található.

## JOGI NYILATKOZAT
Ez az esemény az Európai Unió pénzügyi támogatásával valósul(t) meg a Interreg VI-A IPA Magyarország-Szerbia együttműködési program által. Az esemény tartalmáért teljes mértékben a Wemsical Serbia Ifjúsági és Kulturális Egyesület vállalja a felelősséget, és az semmilyen körülmények között nem tekinthető az Európai Unió és / vagy a programot Irányító Hatóságnak állásfoglalását tükröző tartalomnak.

### A támogató programról:
Az Interreg VI-A IPA Magyarország-Szerbia program a 2021-2027-es Európai Unió pénzügyi keretén belül, az Előcsatlakozási Támogatási Eszköz (IPA) keretében valósul meg. A részt vevő országok – Magyarország és Szerbia – „megosztott irányítási rendszere" alapján a program finanszírozza és támogatja a programterületen található szervezetek együttműködési projektjeit: Magyarországon Csongrád-Csanád - és Bács-Kiskun vármegyében, valamint Szerbiában Nyugat-Bácska, Észak-Bácska, Dél-Bácska, Észak-Bánát, Közép-Bánát, Dél-Bánát és Szerémség közigazgatási területein.

A program segíti a stabil és együttműködő régió kialakulását és az általános életminőséget a határrégióban. Lehetővé teszi a két ország szervezeteinek gazdasági együttműködését, ápolja a határrégió közös identitását, kulturális és történelmi örökségét, hozzájárul környezeti fenntarthatósághoz és biztonságához.

További információkért látogasson el a [www.hungary-serbia.eu](http://www.hungary-serbia.eu) oldalra.`,

      RS: `**Omladinsko i kulturno udruženje Wemsical Serbia**, u saradnji sa partnerskim organizacijama na projektu Parks4All, raspisuje konkurs za umetničku rezidenciju sa ciljem korišćenja, aktivacije i preispitivanja javnih zelenih površina i parkova koji nas okružuju. Projekat je sufinansiran kroz Interreg VI-A IPA Mađarska–Srbija program.

Glavna tema rezidencije je **protest**, a cilj nam je da podržimo, osvetlimo i dokumentujemo nenasilne i nestranačke pokrete koji promovišu temeljne zajedničke vrednosti, jednakost, ljudska prava, moralne i etičke norme, kao i zajednički rad na održivoj, transparentnoj i zajedničkoj budućnosti.

Projekat ima za cilj da pruži prostor i priliku za izraze koji su snažniji od reči i upečatljiviji od agiprop bilborda.

Pozivamo vas da se prijavite i sprovedete svoje ideje u malom, prijatnom parku u Oromu, u okviru festivala Malomfesztivál.

## Šta nudimo:
- **500 evra** za pokrivanje osnovnih troškova kreativnog procesa
- **Tri obroka dnevno** u periodu od 28. jula do 7. avgusta
- **Programe i inspirativne govornike** u večernjim satima
- **Festivalsku propusnicu za Malomfesztivál**

Ne postavljamo tehničke zahteve – rad može biti vizuelna umetnost, land art, instalacija, performans, film ili bilo koji drugi oblik izraza koji se može realizovati u okviru parka ili javnog prostora i festivala.

## Šta očekujemo zauzvrat:
Rad treba da bude tematski relevantan, vizuelno upečatljiv i prilagođen festivalskim i vremenskim uslovima.

**Trajanje rezidencije:** 28. jul – 10. avgust 2025. (moguće je i kraće učešće)

## Uslovi za prijavu:
- **Motivaciono pismo** (maksimalno 1 A4 strana, sa imenom, kontakt podacima, datumom rođenja i mestom prebivališta autora/ke)
- **Profesionalni portfolio**
- **Ideja/plan za rad** koji će biti realizovan ili instaliran na licu mesta

**Rok za prijavu:** 30. jun 2025. do 23:59:59  
**Obaveštenje o rezultatima:** do 5. jula 2025.

**Prijave se šalju na mejl adresu:** onyaolahdora@gmail.com

## Ko može da se prijavi?
Poziv je otvoren za fizička lica (ili grupe autora) **mlađe od 36 godina**, koji su profesionalni ili poluprofesionalni umetnici.

Prijave su moguće i za **timove do 3 osobe** – sa prosečnom starošću do 36 godina. Učesnici mogu biti iz Srbije i/ili Mađarske.

Učešće podrazumeva individualni rad – tehnička i mentorska podrška nisu obezbeđene, iako mogu biti dostupne.

**Radni jezik rezidencije je engleski.**

Prijavom, učesnici se obavezuju da će realizovati svoj plan najbolje što mogu, da će do **6. avgusta 2025. u 14 časova** postaviti svoj rad na lokaciji, da će ga predstaviti tokom festivala i preuzeti odgovornost za njegovo održavanje.

## DODATNE NAPOMENE
Više informacija o projektu Parks4All možete pronaći na [ovom linku](http://www.hungary-serbia.eu).

## ODRICANJE OD ODGOVORNOSTI:
Ovaj dokument i događaj realizovani su uz finansijsku podršku Evropske unije kroz Interreg VI-A IPA Mađarska–Srbija program. Sadržaj dokumenta i događaja predstavlja isključivu odgovornost Omladinskog i kulturnog udruženja Wemsical Serbia i ni u kom slučaju se ne može smatrati da odražava stavove Evropske unije i/ili Upravljačkog tela Programa.

### O sufinansirajućem programu
Program Interreg VI-A IPA Mađarska–Srbija sprovodi se u okviru finansijskog okvira Evropske unije za period 2021–2027, kroz Instrument pretpristupne pomoći (IPA). Na osnovu sistema zajedničkog upravljanja, program finansira i podržava projekte saradnje između organizacija iz prihvatljivih oblasti: županije Čongrad-Čanad i Bač-Kiškun u Mađarskoj, te okruga Zapadnobački, Severnobački, Južnobački, Severnobanatski, Srednjobanatski, Južnobanatski i Sremski u Srbiji.

Cilj programa je razvoj stabilnog regiona saradnje i poboljšanje kvaliteta života u pograničnom području. Podržava ekonomsku saradnju, neguje zajednički identitet i kulturno-istorijsko nasleđe, te doprinosi održivosti i bezbednosti regiona.

Više informacija: [www.hungary-serbia.eu](http://www.hungary-serbia.eu)`,

      EN: `**Wemsical Serbia Youth and Cultural Association** in cooperation with its project partners, announces an artistic residency program within the project Parks4All in order to use, utilize, reevaluate public green spaces, and parks around us. The project is co-financed by the Interreg VI-A IPA Hungary Serbia Programme.

The proposed main subject of the residency is **protest**, by which our goal is to support, reflect on, and document movements free of violence and party politics that promote fundamental shared values, equality, human rights, moral and ethical norms, and a joint work on a common, shared, transparent and sustainable future.

The project would like to provide a space and opportunity for expressions that are louder than words and more spectacular than agitprop billboards.

This is a call for you to apply and implement your ideas in the cosy little park of Orom intertwined with Malomfesztivál.

## What we offer:
- **€500** to cover basic expenses of the creative process
- **Three meals a day** from July 28 to August 7
- **A number of excellent speakers and themed programs** in the evenings
- **Malomfesztivál festival pass**

We have no basic technical requirements; the work can be a visual piece of art, land art, installation, performance, film, or anything else that can be interpreted within the scope of the park/public space and within the scope of Malomfesztivál.

## What we ask in return:
The work should be theme-specific, visually enrapturing, and suitable for the festival and weather conditions.

**Date:** July 28–August 10, 2025 (shorter participation is also possible)

## Application requirements:
- **Letter of motivation** (maximum 1 A4 page, including the name, contact details, date of birth and place of residence of the creator(s))
- **Professional portfolio**
- **Plan/idea for a work** to be created on site or installed there

**Application deadline:** June 30, 2025. 23:59:59  
**The deadline for the evaluation of applications:** July 5 2025.

**Applications should be sent by email to:** onyaolahdora@gmail.com

## Who can apply?
The call is open to any natural persons (or group of creators) **under the age of 36**, independent professional or semi-professional creators.

Applications are accepted for **working groups of up to 3 people** - average no. of age: 36. Groups can have participants from Hungary and/or Serbia.

Participation is based on individual work (technical instructors, mentors, and specialized assistance are not provided, although they may be available).

**The working language of the workshop is English.**

By submitting their application, applicants undertake to implement their plans to the best of their ability, to set up their physical creations on site by **August 6th 2025 2 pm**, at the latest, to present them during Malomfesztivál, and to take responsibility for them.

## ADDITIONAL NOTES
A few words about the Parks4All project can be found under [this link](http://www.hungary-serbia.eu).

## DISCLAIMER:
This document and event has been produced with the financial assistance of the European Union through the Interreg VI-A IPA Hungary-Serbia programme. The content of the document and event is the sole responsibility of Wemsical Serbia Youth and Cultural Association and can under no circumstances be regarded as reflecting the position of the European Union and/or the Managing Authority of the Programme.

### About the co-financing programme
The Interreg VI-A IPA Hungary-Serbia programme is implemented within the 2021-2027 European Union financial framework, under the Instrument for Pre-accession Assistance (IPA). On the basis of "shared management system" of the participating countries - Hungary and Serbia, the Programme funds and supports co-operation projects of organizations located in the Programme-eligible area - Hungarian counties Csongrád-Csanád and Bács-Kiskun, and Serbian territories: West Bačka, North Bačka, South Bačka, North Banat, Central Banat, South Banat and Srem.

The Programme helps the development of a stable and co-operating region and the overall quality of life in the border region. It enables economic collaboration of organizations from the two countries, nurtures the common identity, and cultural and historical heritage of the border region, and contributes to its environmental sustainability and safety.

For more information, please visit: [www.hungary-serbia.eu](http://www.hungary-serbia.eu)`,
    },
  },
];
